<cs-form-generator-nxt [data]="dataContext"

					   [useFormGroup]="parentContext.formGroup"
>

</cs-form-generator-nxt>
